/**
 * @param {Array<BD_RoomMatrixQuestion>} questions
 */
export const getPrettyMatrixData = (questions) => {
    if (!questions) return { questions: [], labels: [] };
    if (questions.length < 1) return { questions: [], labels: [] };

    const firstQuestion = questions[0];
    const rawKeys = Object.keys(firstQuestion).map((k) => k);
    const keys = rawKeys.filter((k) => k !== "name" && k !== "row_id");

    const prettyLabels = keys.map((k) => ({
        text: firstQuestion[k].column_name,
        name: k,
    }));

    const prettyQuestions = questions.map((a) => {
        const row_id = a.row_id;
        const label = a.name;
        const columns = keys.map((k) => ({
            key: k,
            value: a[k]["answer"],
            column_id: a[k]["ID_column"],
            prefilled: a[k]["is_prefilled"],
            textBefore: a[k]["text_before_input"],
            textAfter: a[k]["text_after_input"],
        }));
        return { row_id, label, columns };
    });

    return {
        questions: prettyQuestions,
        labels: prettyLabels,
    };
};
